import * as React from "react";
//@ts-ignore
import backArrow from "../../images/svgs/back-arrow.svg";
import { toast, ToastOptions } from "react-toastify";
import { useCallback } from "react";

interface ToastProps {
  type: "success" | "error" | "info" | "warning";
  message: string;
  options?: ToastOptions;
}

export const Toast = (props: Omit<ToastProps, "options">) => (
  <div
    className={`w-fit flex px-3 justify-center items-center gap-2 rounded-full p-2 ${
      props.type === "success"
        ? "bg-primary-100 text-black-100"
        : props.type === "error"
        ? "bg-error-100 text-white"
        : ""
    }`}
  >
    <img src={backArrow} className="" />
    <p className=" text-sm font-outfit">{props.message}</p>
  </div>
);

export const useToast = () => {
  const showToast = useCallback(
    ({ type = "success", message = "", options }: ToastProps) => {
      let ToastComponent = <Toast message={message} type={type} />;
      toast(ToastComponent, options);
    },
    []
  );

  return showToast;
};
